import React from 'react';
import { PropTypes } from 'prop-types';

import Link from 'components/styled/link';

const LegalInfo = ({
  className,
  conditionsUrl,
  insuranceUrl,
  hasInsurance,
  t,
}) => (
  <div className={className}>
    {t('legal_info_text_1')}{' '}
    <Link
      size="L"
      href={conditionsUrl}
      target="_blank"
      text={t('legal_general_conditions_text')}
      className="summary-legal-link"
    />
    {hasInsurance && (
      <>
        {' '}
        {t('legal_info_text_2')}{' '}
        <Link
          size="L"
          href={insuranceUrl}
          target="_blank"
          text={t('legal_insurance_conditions_text')}
          className="summary-legal-link"
        />
      </>
    )}
  </div>
);

LegalInfo.propTypes = {
  className: PropTypes.string,
  conditionsUrl: PropTypes.string.isRequired,
  insuranceUrl: PropTypes.string,
  hasInsurance: PropTypes.bool,
  t: PropTypes.func,
};

LegalInfo.defaultProps = {
  className: '',
  insuranceUrl: '',
  hasInsurance: false,
  t: () => {},
};

export default LegalInfo;
